import moment from "moment";

/**
 * Returns an object woth end and start date
 * to be used in frecuency request
 *
 * @param {String} type
 */
export const getDateObject = (type) => {
  switch (type) {
    case "TODAY":
      return {
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
      };
    case "YESTERDAY":
      return {
        start: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        end: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
      };
    case "CURRENT_MONTH":
      return {
        start: moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end: moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
      };
    case "LAST_MONTH":
      return {
        start: moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD"),
        end: moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD"),
      };
    case "CURRENT_YEAR":
      return {
        start: moment()
          .startOf("year")
          .format("YYYY-MM-DD"),
        end: moment()
          .endOf("year")
          .format("YYYY-MM-DD"),
      };
    default:
      return undefined;
  }
};

export const DATE_TYPE_BY_TAB_FORMAT = {
  Dia: "TODAY",
  Mes: "CURRENT_MONTH",
  Año: "CURRENT_YEAR",
};
